import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import About from '../components/About';
const Nosotros = () => {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-321">
      <Header data-id="element-322" />
      <main data-id="element-323">
        <About data-id="element-324" />
      </main>
      <Footer data-id="element-325" />
    </div>;
};
export default Nosotros;